export default () => ({
    accion:null,
    id_ruex_solicitud:null,
})